// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._51997a{background:linear-gradient(var(--background) 70%, rgba(255, 255, 255, 0));margin-top:calc(-1*var(--medium-spacer));padding:var(--medium-spacer) 0 var(--spacer);position:sticky;top:var(--top-bar-height);z-index:10}@media print{._51997a{position:relative;top:auto}}._51997a+*{margin-top:0 !important}._51997a .ef79ca{font-size:.875em}._51997a._73c5aa+*{margin-right:calc(10rem + var(--medium-spacer))}._51997a._73c5aa .ef79ca{position:absolute;top:var(--medium-spacer);right:0;width:10rem}._51997a._73c5aa .ef79ca._4cbba1{top:100%}[aria-roledescription=modal] ._51997a{top:calc(-1*var(--medium-spacer));margin-top:calc(-1*var(--medium-spacer))}", ""]);
// Exports
exports.locals = {
	"header": "_51997a",
	"menu": "ef79ca",
	"has-sidebar": "_73c5aa",
	"hasSidebar": "_73c5aa",
	"shift": "_4cbba1"
};
module.exports = exports;
